import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { RacingPostIcon } from 'src/domains/layouts/shared/assets/icons/RacingPostIcon';

import { withConfig } from 'src/withConfig';

import { DoubleArrowUpIcon } from 'src/ui/assets/icons/arrow/DoubleArrowUpIcon';



export const TabsSection = withConfig(theme => styled('section', { label: 'TabsSection' })`

    background-color: ${theme.star.tabsColors.bgColor};

    position: relative;

`);



interface TabsUlPropsType {

    variant: DefaultComponentVariantType | null;

}



const setTabsUl = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css``;

    }

    return css`

        border-color: ${theme.star.raceCard.filters.type.borderColor};

        border-style: solid;

        border-width: 1px 1px 0 1px;

    `;

};



export const TabsUl = withConfig(theme => styled('nav', { label: 'TabsUl' })<TabsUlPropsType>`

    ${({ variant }): SerializedStyles=> setTabsUl(variant, theme)};

    align-items: center;

    background-color: ${theme.star.raceCard.filters.time.bgColor};

    display: flex;

    flex-flow: row nowrap;

    font-size: ${theme.star.fontSize.small};

    font-weight: ${theme.star.fontWeight.medium};

    justify-content: flex-start;

    overflow-x: auto;

    padding: 8px;

    @media ${theme.star.mediaQuery.desktop} {

        overflow: hidden;

    }

`);



export const TabsContent = withConfig(theme => styled('div', { label: 'TabsContent' })`

    color: ${theme.star.tabsColors.txtColor};

`);



export const RacingPostIndicator = styled(RacingPostIcon, { label: 'RacingPostIndicator' })`

    fill: currentcolor;

    flex: 0 0 16px;

    width: 16px;

`;



export const PriceBoostIndicator = styled(DoubleArrowUpIcon, { label: 'PriceBoostIndicator' })`

    fill: currentcolor;

    flex: 0 0 16px;

    width: 16px;

`;

